// uses styleguide/loading.less
import PropTypes from 'prop-types';

import React from 'react';

const DEFAULT_MESSAGE = 'Loading...';

/**
 * We had to replace <div className="spinner"></div> to <span className="spinner"></span>
 * because we get IE11 win8.1 error, where browser after replacing loader with content still reuse animation.
 */
const Loading = (props) =>
    props.isLoaded ? (
        props.children
    ) : (
        <div className="sg-loading">
            <span className="spinner" />
            <div className="message">{props.message || DEFAULT_MESSAGE}</div>
        </div>
    );

Loading.propTypes = {
    message: PropTypes.string,
    isLoaded: PropTypes.bool.isRequired,
    children: PropTypes.node, // .isRequired
};

export default Loading;
